// @flow

import React, { Component } from 'react';
import { Button, Col, Glyphicon, Well, Row } from 'react-bootstrap';
import './styles.css';

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = { shortOutbound: true, shortInbound: true };
  }

  transferInfoOutbound = desc => {
    if (!this.props.options.selectedTransferTypeDataOutbound['code']) return null;
    return this.props.options.selectedTransferTypeDataOutbound[desc].map((val, index) => {
      return (
        <Row className="info-row" key={index}>
          <Col>
            <div style={{ display: 'flex' }}>
              <Glyphicon glyph="ok" style={{ marginRight: '5px' }} />
              <div
                dangerouslySetInnerHTML={{
                  __html: val
                }}
              />
            </div>
          </Col>
        </Row>
      );
    });
  };

  transferInfoInbound = desc => {
    if (!this.props.options.selectedTransferTypeDataInbound['code']) return null;
    return this.props.options.selectedTransferTypeDataInbound[desc].map((val, index) => {
      return (
        <Row className="info-row" key={index}>
          <Col>
            <div style={{ display: 'flex' }}>
              <Glyphicon glyph="ok" style={{ marginRight: '5px' }} />
              <div
                dangerouslySetInnerHTML={{
                  __html: val
                }}
              />
            </div>
          </Col>
        </Row>
      );
    });
  };

  handleShortOutboundChange = () => {
    this.setState({ shortOutbound: false });
  };

  handleShortInboundChange = () => {
    this.setState({ shortInbound: false });
  };

  render() {
    const { options } = this.props;
    if (!this.props.options.selectedTransferTypeDataOutbound['code']) return null;
    return (
      <Well className="">
        <Row>
          {this.props.journeyType === 'outbound' ? (
            <Col className={`text-left info`}>
              <Row>
                <Col>
                  <h4>
                    Transfer type:{' '}
                    <strong>
                      {options.selectedTransferTypeDataOutbound && options.selectedTransferTypeDataOutbound.description}
                    </strong>
                  </h4>
                </Col>
              </Row>
              {this.state.shortOutbound
                ? this.transferInfoOutbound('descriptionShort')
                : this.transferInfoOutbound('descriptionLong')}
              <Row>
                <div className="text-center">
                  {this.state.shortOutbound ? (
                    <Button bsStyle="success" onClick={this.handleShortOutboundChange}>
                      <span>EXPAND FOR MORE INFO</span>
                    </Button>
                  ) : null}
                </div>
              </Row>
            </Col>
          ) : null}
          {this.props.journeyType === 'inbound' ? (
            <Col className="text-left info">
              <Row>
                <Col>
                  <h4>
                    Transfer type:{' '}
                    <strong>
                      {options.selectedTransferTypeDataInbound && options.selectedTransferTypeDataInbound.description}
                    </strong>
                  </h4>
                </Col>
              </Row>
              {this.state.shortInbound
                ? this.transferInfoInbound('descriptionShort')
                : this.transferInfoInbound('descriptionLong')}
              <Row>
                <div className="text-center">
                  {this.state.shortInbound ? (
                    <Button bsStyle="success" onClick={this.handleShortInboundChange}>
                      <span>EXPAND FOR MORE INFO</span>
                    </Button>
                  ) : null}
                </div>
              </Row>
            </Col>
          ) : null}
        </Row>
      </Well>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ConfirmPage/Ticks/index.js